export const NEUTRAL_DATE_FORMAT = "YYYY-MM-DD";
export const NEUTRAL_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const DATE_FILTERS = Object.freeze({TODAY: "Today", TOMORROW: "Tomorrow", FUTURE: "Future"})

//value: value
export const ITEM_TYPE = {
    INDEPENDENT: "INDEPENDENT",
    SERIAL: "SERIAL",
    SERIAL_INSTANCE: "SERIAL_INSTANCE"
}